/// <amd-module name="Dashboards/DashboardView/src/model/Dashboard" />
import { DashboardScope } from "Dashboards/Common/Contracts/Dashboard";
import { DeepReadonly } from "./DeepReadonly";

/**
 * Subset of the dashboard contract that we need to track in Redux state.
 * Should only be consumed by 'produce' in the reducer as the singular place state can be modified.
 */
export interface WriteableDashboard {
    id: string;
    name: string;
    description: string;
    groupId: string;
    ownerId: string;
    dashboardScope: DashboardScope;
    refreshInterval: number;
    eTag: string;
    lastAccessedDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
}

/** A dashboard that cannot be modified */
export interface Dashboard extends DeepReadonly<WriteableDashboard> {}

export interface DashboardOwner {
    id: string;
    name: string;
}
